const getInitial = (name: string) => (name?.[0] ?? '').toUpperCase();

/**
 * Returns the first and last initials for the `model` with the properties
 * `firstName` and `lastName`. The initials are returned uppercase.
 *
 * Accepts any record exposing `firstName`/`lastName` — the legacy Person /
 * Employee / Agent models, their schema-derived resource types, or the
 * `*Extension` types — so callers across the migration boundary all type-check.
 *
 * @param model A record that has `firstName` and `lastName` properties
 *
 * @return {string} The initials for the model
 */
const getInitials = (model: { firstName?: string | null; lastName?: string | null }) =>
  `${getInitial(model.firstName ?? '')}${getInitial(model.lastName ?? '')}`;

export { getInitials };

export default null; // silence a false warning
